// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './routes';
import store from './store';
import axios from 'axios';
import Buefy from 'buefy';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import VueRandomColor from 'vue-randomcolor'
import JsonExcel from 'vue-json-excel'
import JsonCSV from 'vue-json-csv'
import VueFeather from 'vue-feather';
import VueApexCharts from 'vue-apexcharts'
import VueChatScroll from 'vue-chat-scroll'
import io from 'socket.io-client'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import {apiHost} from '@/config/config';
import 'jodit/build/jodit.min.css'
import JoditVue from 'jodit-vue'
import XLSX from 'xlsx';
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Buefy);
Vue.use(Vuetify)
Vue.use(VueNumberInput);
Vue.use(VueRandomColor);
Vue.use(JsonExcel);
Vue.use(JsonCSV);
Vue.use(VueFeather);
Vue.use(VueApexCharts);
Vue.use(VueChatScroll);
Vue.use(Viewer);
Vue.use(JoditVue);
Vue.use(XLSX);

Vue.component('downloadCsv', JsonCSV)
Vue.component('downloadExcel', JsonExcel);
Vue.component('vue-feather', VueFeather);
Vue.component('apexchart', VueApexCharts);

const socket = io(apiHost);

Vue.prototype.$http = axios;
Vue.prototype.$axios = axios;
Vue.prototype.$store = store;
Vue.prototype.$apiHost = apiHost;
// Vue.prototype.$analysisHost = analysisHost;
Vue.prototype.$socket = socket;
Vue.config.productionTip = false;

export const bus = new Vue(); // menuHeader data used

const vuetifyOptions = { }

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    Buefy,
    vuetify: new Vuetify(vuetifyOptions),
    render: h => h(App),
    template: '<App/>',
    components: {
        App
    }
});


// WEBPACK FOOTER //
// ./src/main.js